import dayjs from 'dayjs'
import { isNotData } from './functional'
import { insert, isNil } from 'ramda'
import timeout from './timeout'
import copy from 'copy-to-clipboard'
import wx from 'weixin-js-sdk'

export function timeStamp() {
  return Math.floor(new Date().getTime() / 1000)
}

export function promiseValidate(form) {
  return new Promise((resolve, reject) => {
    form.validate(resolve)
  })
}

export function promiseValidateField(form, arr) {
  return new Promise((resolve, reject) => {
    form.validateField(arr, (err) => {
      if (!err) {
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
}

export function getUnixTime(t, isEndTime = false) {
  const time = do {
    if (isEndTime) {
      ;`${t} 23:59:59`
    } else {
      t
    }
  }
  return dayjs(time).unix()
}

export function formatUnixTime(t, fmt = 'YYYY-MM-DD HH:mm') {
  return dayjs(t * 1000).format(fmt)
}

export function formatTime(t, fmt = 'YYYY-MM-DD HH:mm') {
  if (!t) return '-'
  return dayjs(t).format(fmt)
}

export function formatShowTime(t, fmt = 'YYYY/MM/DD HH:mm') {
  return dayjs(t).format(fmt)
}

export function tranformTimeNode(t, fmt = 'YYYY-MM-DD HH:mm') {
  return formatTime(dayjs().hour(t), fmt)
}

export function splitNumber(n) {
  if (n < 1000) {
    return n
  } else {
    const s = n.toString()
    return insert(1, ',', s).join('')
  }
}

/*数字转换*/
export function getNumberShow(n) {
  if (isNotData(n)) {
    return '-'
  }
  if (n < 0) {
    return `-${getNumberShow(-n)}`
  }
  if (n < 10000) {
    return splitNumber(n)
  } else if (n < 100000000) {
    const w = n / 10000
    return `${splitNumber(Math.round(w * 10) / 10)}w`
  } else {
    const w = n / 100000000
    return `${splitNumber(Math.round(w * 100) / 100)}亿`
  }
}
/*数字转换*/
export function getNumberShowFloor(n) {
  if (isNotData(n)) {
    return '-'
  }
  if (n < 0) {
    return `-${getNumberShow(-n)}`
  }
  if (n < 10000) {
    return splitNumber(n)
  } else if (n < 100000000) {
    const w = n / 10000
    return `${splitNumber(Math.floor(w * 10) / 10)}w`
  } else {
    const w = n / 100000000
    return `${splitNumber(Math.floor(w * 100) / 100)}亿`
  }
}
/*数字销量转换*/
export function getSalesNumberShow(n) {
  if (isNotData(n)) {
    return '-'
  }
  if (n < 0) {
    return `-${getNumberShow(-n)}`
  }
  if (n < 10000) {
    if (n >= 1000) {
      return (n + '').charAt(0) + 'k+'
    } else {
      return n
    }
  } else if (n < 100000000) {
    const w = n / 10000
    return `${splitNumber(Math.floor(w))}w+`
  } else {
    const w = n / 100000000
    return `${splitNumber(Math.floor(w))}亿+`
  }
}

/**
 * 大数字转换 将数字分段显示，每三位用逗号隔开
 * @param num 数字值
 */
export function formatNumber(num, precision, separator) {
  let parts
  // 判断是否为数字
  if (!isNaN(parseFloat(num)) && isFinite(num)) {
    // 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
    // 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
    // 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
    // 的值变成了 12312312.123456713
    num = Number(num)
    // 处理小数点位数
    num = (typeof precision !== 'undefined' ? num.toFixed(precision) : num).toString()
    // 分离数字的小数部分和整数部分
    parts = num.split('.')
    // 整数部分加[separator]分隔, 借用一个著名的正则表达式
    parts[0] = parts[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (separator || ','))

    return parts.join('.')
  }
  return NaN
}

/*电子邮箱验证*/
export function isEmail(mail) {
  // eslint-disable-next-line prefer-regex-literals
  const filter = new RegExp('^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$')
  if (filter.test(mail)) {
    return true
  } else {
    return false
  }
}

/*身份证号码验证*/
export function isCardId(id) {
  // eslint-disable-next-line prefer-regex-literals
  const filter = new RegExp('^(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)')
  if (filter.test(id)) {
    return true
  } else {
    return false
  }
}

/* 保留两位小数 */
export function keepTwoFloat(t) {
  const num = parseFloat(t)
  return num.toFixed(2)
}

/* 格式化百分比 */
export function formatDecimal(num, decimal) {
  num = num.toString()
  const index = num.indexOf('.')
  if (index !== -1) {
    num = num.substring(0, decimal + index + 1)
  } else {
    num = num.substring(0)
  }
  return parseFloat(num).toFixed(decimal)
}

export function formatPrice(num, fixed = 2) {
  if (typeof num == 'string') {
    const num1 = parseFloat(num)
    if (isNaN(num1)) {
      return num
    } else {
      num = num1
    }
  }
  return num.toFixed(fixed).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
}

export async function mockPromise(data, d = 1000) {
  await timeout(d)
  return { data }
}

/*判断是否是移动端*/
export function isMobile() {
  if (/iPad/.test(navigator.userAgent)) {
    return false
  }
  if (/(iPhone|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

//将秒数转换为时分秒中文格式
export function formatSeconds(value, isZer = true, showSecond = false, m = true) {
  //m为显示的两种格式，即0′0′′或时分秒
  const time = parseInt(value)
  let second = 0 // 秒
  let minute = 0 // 分
  let hour = 0 // 小时
  let day = 0 // 天
  let result = ''
  if (time == 0) {
    result = do {
      if (isZer) {
        ;('--')
      } else {
        if (m) {
          0
        } else {
          ;('0′0′′')
        }
      }
    }
  } else {
    if (time > 60) {
      minute = parseInt(time / 60)
      second = parseInt(time % 60)
      if (minute > 60) {
        hour = parseInt(minute / 60)
        minute = parseInt(minute % 60)
      }
      if (hour > 24) {
        day = parseInt(hour / 24)
        hour = parseInt(hour % 24)
      }
    } else {
      second = time
    }
    if (m) {
      if (second > 0 || showSecond) {
        result = '' + parseInt(second) + '秒' + result
      }
      if (minute > 0) {
        result = '' + parseInt(minute) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '小时' + result
      }
      if (day > 0) {
        result = '' + parseInt(day) + '天' + result
      }
    } else {
      if (second > 0) {
        result = '' + parseInt(second) + '′′' + result
      }
      if (minute > 0) {
        result = '' + parseInt(minute) + '′' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + ':' + result
      }
    }
  }
  return result
}
/*小数转百分数*/
export function valueToPercent(value, fix = 2) {
  if (!value) return 0
  value = value + ''
  const pointIndex = value.indexOf('.')
  if (pointIndex === -1) return ((value - 0) * 100).toFixed(fix)
  const powIndex = value.length - pointIndex - 1
  return ((value.replace('.', '') - 0) * Math.pow(10, 2 - powIndex)).toFixed(fix)
}
/*修改title*/
export function changeTitle(t) {
  document.getElementsByTagName('title')[0].innerText = t
}

export const DESCRIPTION =
  '蝉选是蝉妈妈出品的抖音电商免费选品平台。为达人提供海量爆品和数字化选品服务，实现带货爆发；为商家链接全网达人，实现商品快速分销，促进生意增长。'

/*修改description*/
export function changeDescription(t = DESCRIPTION) {
  document.querySelector('meta[name="description"]').setAttribute('content', t)
}

/*修改keywords*/
export function changeKeyWords(t) {
  document.querySelector('meta[name="keywords"]').setAttribute('content', t)
}

/*判断是否是微信浏览器*/
export function isWeixin() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  const ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
/*判断是否是苹果浏览器*/
export function isSafari() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  const ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1) {
    return true
  } else {
    return false
  }
}
/*判断是否是chrome浏览器*/
export function isChrome() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  const ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.indexOf('chrome') > -1) {
    return true
  } else {
    return false
  }
}
export function solveCdnImgUrlResize(w, url) {
  if (!url) {
    return url
  }

  return `${url}${do {
    if (url.indexOf('?') == -1) {
      ;('?')
    } else {
      ;('&')
    }
  }}x-oss-process=image/resize,w_${2 * w}`
}

export function safariWebpCompatible(url) {
  if (isSafari()) {
    const compatibleUrl = url.replace(/\/pics\//g, '/pics_jpg/').replace(/\.webp/g, '.jpg')
    return compatibleUrl
  } else {
    return url
  }
}
/**
 * 格式化分钱为单位的金额
 *
 * @param {*} mail
 * @returns
 */
export function formatPenny(pennyNum) {
  if (isNil(pennyNum)) return '-'
  return formatNumber(pennyNum / 100, 2)
}
/**
 * 格式化分钱为单位的金额
 *
 * @param {*} mail
 * @returns
 */
export function formatPennyFloat(pennyNum) {
  if (isNil(pennyNum)) return '-'
  const floatNum = parseFloat(pennyNum / 100)
  return formatNumber(floatNum)
}
/**
 * 格式化分钱为单位的金额 - 大金额转换
 *
 * @param {*} pennyNum
 * @returns
 */
export function formatPennyBigMoney(pennyNum) {
  if (isNil(pennyNum)) return '-'
  const floatNum = parseFloat(pennyNum / 100)
  if (floatNum - 0 >= 10000) return bigNumFormat(floatNum)
  return formatPenny(pennyNum)
}
export function bigNumFormat(num, decimalNum = 1) {
  if (isNil(num)) return ''
  const forNum = num - 0
  if (forNum >= 10000) {
    if (forNum < 100000000) {
      return `${splitNumber(Math.floor(forNum / 10000))}${getDecimal(forNum / 10000, decimalNum)}w`
    } else {
      return `${splitNumber(Math.floor(forNum / 100000000))}${getDecimal(forNum / 100000000, decimalNum)}亿`
    }
  } else {
    return splitNumber(forNum)
  }
}

function getDecimal(num, decimalNum = 2) {
  const str = num + ''
  const decialNum = str.split('.')
  if (decialNum.length > 1) {
    const decimalStr = decialNum[1].substring(0, decimalNum)
    const delZeroNum = endDelZero(decimalStr)
    return `${delZeroNum ? '.' + delZeroNum : ''}`
  } else {
    return ''
  }
}
function endDelZero(num) {
  const str = num + ''
  return str.replace(/(0+)$/g, '')
}

export function replaceWan(str) {
  if (!str) {
    return ''
  } else {
    return str.replace(/万/g, 'w')
  }
}

export function getUrlParam(link, name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const s = link.split('?')[1] ?? ''
  const r = s.match(reg)
  let strValue = ''
  if (r != null) {
    strValue = unescape(r[2])
  }
  return strValue
}

// 压缩前将file转换成img对象
export function readImg(file) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const reader = new FileReader()
    reader.onload = function (e) {
      img.src = e.target.result
    }
    reader.onerror = function (e) {
      reject(e)
    }
    reader.readAsDataURL(file)
    img.onload = function () {
      resolve(img)
    }
    img.onerror = function (e) {
      reject(e)
    }
  })
}
/**
 * 压缩图片
 *@param img 被压缩的img对象
 * @param type 压缩后转换的文件类型
 * @param mx 触发压缩的图片最大宽度限制
 * @param mh 触发压缩的图片最大高度限制
 */
export function compressImg(img, type, mx, mh) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const { width: originWidth, height: originHeight } = img
    // 最大尺寸限制
    const maxWidth = mx
    const maxHeight = mh
    // 目标尺寸
    let targetWidth = originWidth
    let targetHeight = originHeight
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > 1) {
        //  宽图片
        targetWidth = maxWidth
        targetHeight = Math.round(maxWidth * (originHeight / originWidth))
      } else {
        // 高图片
        targetHeight = maxHeight
        targetWidth = Math.round(maxHeight * (originWidth / originHeight))
      }
    }
    canvas.width = targetWidth
    canvas.height = targetHeight
    context.clearRect(0, 0, targetWidth, targetHeight)
    // 图片绘制
    context.drawImage(img, 0, 0, targetWidth, targetHeight)
    canvas.toBlob(function (blob) {
      resolve(blob)
    }, type || 'image/png')
  })
}

/**
 * 四舍五入
 * @param  {number} num     [待处理数字]
 * @param  {number} decimal [需要保留的小数位]
 * @return {number}
 */
export function round(num, decimal = 2) {
  if (isNaN(num)) {
    console.error(`round error, '${num}' is not a number`)
    return 0
  }
  const p1 = Math.pow(10, decimal + 1)
  const p2 = Math.pow(10, decimal)
  return (Math.round((num * p1) / 10) / p2).toFixed(decimal) |> Number
}

// 复制文字到粘贴板
export const copyToClip = (content) => {
  const aux = document.createElement('input')
  aux.setAttribute('value', content)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
}

/*奇偶判断*/
export function isEven(num) {
  return num % 2 !== 0
}

// 分秒针换算时间
export function sec2Time(s) {
  if (!s) {
    return '--'
  }
  let h
  h = Math.floor(s / 60)
  s = s % 60
  h += ''
  s += ''
  const sf = +s < 10 ? '0' + s.split('.')[0] : s.split('.')[0]
  if (h != 0) {
    return h + '分钟' + sf + '秒'
  } else {
    return sf + '秒'
  }
}

export async function preLoadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = url
    img.onload = function () {
      resolve()
    }
    img.onerror = function (e) {
      console.log(e)
      reject(e)
    }
  })
}

export function getCXAvatar(avatar) {
  return avatar
    ? avatar === 'https://cdn-static.chanmama.com/images/no-image.png'
      ? solveCdnImgUrlResize(100, require('@cdn?8604bcf416e7'))
      : avatar
    : ''
}
// 复制粘贴函数
export async function copyTextToClip(text) {
  return new Promise((resolve, reject) => {
    try {
      setTimeout(() => {
        copy(text)
        resolve()
      }, 50)
    } catch (error) {
      reject()
    }
  })
}

export function base64ToBlob(code) {
  let parts = code.split(';base64,')
  let contentType = parts[0].split(':')[1]
  let raw = window.atob(parts[1])
  let rawLength = raw.length
  let uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], {
    type: contentType
  })
}

export function queryToUrl(query = {}) {
  let urlStr = ''
  let keyList = []
  Object.keys(query).forEach((item) => {
    keyList.push(item)
  })
  if (keyList.length > 0) {
    urlStr = '?'
    keyList.forEach((key, idx) => {
      urlStr = urlStr + key + '=' + query[key] + (idx != keyList.length - 1 ? '&' : '')
    })
    return urlStr
  }
  return ''
}

/**
 * @description: 判断浏览器环境， miniProgram 微信小程序环境 ； wxWeb 微信浏览器环境； others 其他浏览器
 * @param {*}
 * @return {promise}
 * @author:
 */
export const getBrowserEnv = () => {
  return new Promise((resolve) => {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //微信环境下
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          // 小程序环境下逻辑
          resolve('miniProgram')
        } else {
          //非小程序环境下逻辑
          resolve('wxWeb')
        }
      })
    } else {
      resolve('others')
    }
  })
}
export function urlDelParams(url, name) {
  const re = new RegExp('&?' + name + '=[^&]*', 'g')
  return url.replace(re, '')
}

export const isElementNotInViewport = (el) => {
  let rect = el.getBoundingClientRect()
  return rect.top >= (window.innerHeight || document.documentElement.clientHeight) || rect.bottom <= 0
}

export async function handleVariable(variable) {
  let result

  // 如果 variable 是一个函数
  if (typeof variable === 'function') {
    // 如果 variable 是一个异步函数
    if (variable.constructor.name === 'AsyncFunction') {
      result = await variable()
    } else {
      // 如果 variable 是一个同步函数
      result = variable()
    }
  } else if (typeof variable === 'string') {
    // 如果 variable 是一个字符串
    result = variable
  } else {
    throw new Error('Invalid type: variable must be a string or a function')
  }

  return Promise.resolve(result)
}

export function getSection(d) {
  // const iSwhite = store.state.user.info && store.state.user.info.is_value_white
  const iSwhite = false
  const n = do {
    if (isNotData(d)) {
      ;('-')
    } else if (parseInt(d) != d) {
      keepTwoFloat(d)
    } else {
      d
    }
  }
  if (iSwhite) {
    return getNumberShow(n)
  }
  if (isNotData(n)) {
    return '-'
  }

  if (n == 0) {
    return '0'
  }

  if (n < 0) {
    return `- ${getSection(-n)} `
  }

  function getStr(i, j, m) {
    let s = i * m
    if (m > 1 && i == 0) {
      s = m * 10
    }
    if (m == 1 && i == 0) {
      s = 1
    }
    return `${getNumberShow(s)} ~${getNumberShow(j * m)} `
  }

  let m = 1
  while (m <= 10000000000) {
    if (n < 25 * m) return getStr(0, 25, m)

    if (n < 50 * m) return getStr(25, 50, m)

    if (n < 75 * m) return getStr(50, 75, m)

    if (n < 100 * m) return getStr(75, 100, m)

    m = m * 10
  }
}
